export const RFInitialValues = {
  title: '',
  balCodeId: '',
  accNo: '',
  personalNo: '',
  currenciesDisabled: true,
  currencies: 'EUR',
  accTypesDisabled: true,
  accTypes: 1,
  nodesDisabled: true,
  nodes: 0,
  status: 2,
}

export const SELECTOR_NAME = 'ACCOUNTS_SELECTOR'

export const INSTANCE_NAME = 'ACCOUNTS'

export const formName = 'frm_acc_search'
export const objectName = 'dbgrd_acc_lists'

export const formNameSelector = 'frm_account_select'
